/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.28/esri/copyright.txt for details.
*/
import { _ as t } from "../../chunks/tslib.es6.js";
import e from "../../TimeExtent.js";
import r from "../../TimeInterval.js";
import { JSONSupport as o } from "../../core/JSONSupport.js";
import { clone as s } from "../../core/lang.js";
import { setDeepValue as n } from "../../core/object.js";
import { property as p } from "../../core/accessorSupport/decorators/property.js";
import "../../core/accessorSupport/ensureType.js";
import { reader as i } from "../../core/accessorSupport/decorators/reader.js";
import { subclass as l } from "../../core/accessorSupport/decorators/subclass.js";
import { writer as u } from "../../core/accessorSupport/decorators/writer.js";
var a;
let m = a = class extends o {
  constructor(t) {
    super(t), this.currentTimeExtent = null, this.fullTimeExtent = null, this.loop = !1, this.numStops = null, this.numThumbs = null, this.stopDelay = null, this.stopInterval = null, this.stops = null;
  }
  readCurrentTimeExtent(t) {
    if (!t) return;
    const r = null != t[0] ? new Date(t[0]) : null,
      o = null != t[1] ? new Date(t[1]) : null;
    return new e({
      start: r,
      end: o
    });
  }
  writeCurrentTimeExtent(t, e, r) {
    t && n(r, [null != t.start ? t.start.getTime() : null, null != t.end ? t.end.getTime() : null], e);
  }
  readFullTimeExtent(t, r) {
    const o = r.properties;
    if (!o) return;
    const s = null != o.endTime ? new Date(o.endTime) : null,
      n = null != o.startTime ? new Date(o.startTime) : null;
    return new e({
      start: n,
      end: s
    });
  }
  writeFullTimeExtent(t, e) {
    if (!t) return;
    const r = e.properties = e.properties || {},
      o = t.end,
      s = t.start;
    o && (r.endTime = null != o ? o.getTime() : null), s && (r.startTime = null != s ? s.getTime() : null);
  }
  readStopInterval(t, e, o) {
    return t ? r.fromJSON({
      value: t.interval,
      unit: t.units
    }, o) : null;
  }
  writeStopInterval(t, e, r, o) {
    if (!t) return;
    const s = t.toJSON(o);
    n(r, {
      interval: s.value,
      units: s.unit
    }, e);
  }
  readStops(t) {
    return t?.length ? t.map(t => new Date(t)) : null;
  }
  writeStops(t, e, r) {
    t?.length && n(r, t.map(t => t.getTime()), e);
  }
  clone() {
    return new a(s({
      currentTimeExtent: this.currentTimeExtent,
      fullTimeExtent: this.fullTimeExtent,
      loop: this.loop,
      numStops: this.numStops,
      numThumbs: this.numThumbs,
      stopDelay: this.stopDelay,
      stopInterval: this.stopInterval,
      stops: this.stops
    }));
  }
};
t([p({
  type: e,
  json: {
    read: {
      source: "properties.currentTimeExtent"
    },
    write: {
      target: "properties.currentTimeExtent"
    }
  }
})], m.prototype, "currentTimeExtent", void 0), t([i("currentTimeExtent")], m.prototype, "readCurrentTimeExtent", null), t([u("currentTimeExtent")], m.prototype, "writeCurrentTimeExtent", null), t([p({
  type: e,
  json: {
    read: {
      source: ["properties.endTime", "properties.startTime"]
    },
    write: {
      target: {
        "properties.endTime": {
          type: Number
        },
        "properties.startTime": {
          type: Number
        }
      }
    }
  }
})], m.prototype, "fullTimeExtent", void 0), t([i("fullTimeExtent")], m.prototype, "readFullTimeExtent", null), t([u("fullTimeExtent")], m.prototype, "writeFullTimeExtent", null), t([p({
  type: Boolean,
  nonNullable: !0,
  json: {
    default: !1,
    read: {
      source: "properties.loop"
    },
    write: {
      target: "properties.loop"
    }
  }
})], m.prototype, "loop", void 0), t([p({
  type: Number,
  json: {
    read: {
      source: "properties.numberOfStops"
    },
    write: {
      target: "properties.numberOfStops",
      overridePolicy() {
        const t = !!this.stopInterval,
          e = !!this.stops?.length,
          r = !(t || e);
        return {
          enabled: r,
          isRequired: r
        };
      }
    }
  }
})], m.prototype, "numStops", void 0), t([p({
  type: [1, 2],
  nonNullable: !0,
  json: {
    read: {
      source: "properties.thumbCount"
    },
    write: {
      target: "properties.thumbCount",
      isRequired: !0
    }
  }
})], m.prototype, "numThumbs", void 0), t([p({
  type: Number,
  nonNullable: !0,
  json: {
    read: {
      source: "properties.thumbMovingRate"
    },
    write: {
      target: "properties.thumbMovingRate",
      isRequired: !0
    }
  }
})], m.prototype, "stopDelay", void 0), t([p({
  type: r,
  json: {
    read: {
      source: "properties.timeStopInterval"
    },
    write: {
      target: "properties.timeStopInterval",
      overridePolicy() {
        const t = null != this.numStops,
          e = !!this.stops?.length;
        return {
          enabled: !e,
          isRequired: !(t || e)
        };
      }
    }
  }
})], m.prototype, "stopInterval", void 0), t([i("stopInterval")], m.prototype, "readStopInterval", null), t([u("stopInterval")], m.prototype, "writeStopInterval", null), t([p({
  type: [Date],
  json: {
    read: {
      source: "properties.stops"
    },
    write: {
      target: "properties.stops",
      overridePolicy() {
        return {
          isRequired: null == this.numStops && !this.stopInterval
        };
      }
    }
  }
})], m.prototype, "stops", void 0), t([i("stops")], m.prototype, "readStops", null), t([u("stops")], m.prototype, "writeStops", null), m = a = t([l("esri.webdoc.widgets.TimeSlider")], m);
const c = m;
export { c as default };